(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-ebay-feedback"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bb-feedback')) {
    customElements.define('bb-feedback', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bb-feedback-track');
        if (!this.track || this.events) return;
        this.cards = [...this.querySelectorAll('.bb-feedback-card')];
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.hovered = false;
        this.visible = false;
        this.toggle = this.querySelector('[data-feedback-toggle]');
        this.controls = this.querySelector('[data-feedback-controls]');
        this.position = this.querySelector('[data-feedback-position]');
        this.previous = this.querySelector('[data-feedback-previous]');
        this.next = this.querySelector('[data-feedback-next]');
        this.previous.addEventListener('click', () => { this.pause(); this.move(-1); }, options);
        this.next.addEventListener('click', () => { this.pause(); this.move(1); }, options);
        this.toggle?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.update();
        }, options);
        this.track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.pause();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.track.addEventListener('pointerdown', () => this.pause(), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', event => {
          if (event.target !== this.toggle) this.pause();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.paused = true;
          this.update();
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.intersection = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0.15 });
        this.intersection.observe(this);
        this.update();
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.bb-feedback-card');
          if (!card) return;
          this.pause();
          this.track.scrollTo({ left: card.offsetLeft - this.cards[0].offsetLeft, behavior: 'auto' });
        }, options);
      }
      pause() { this.paused = true; this.update(); }
      move(direction) {
        const first = this.cards[0];
        const max = this.track.scrollWidth - this.track.clientWidth;
        const step = this.cards.length > 1 ? this.cards[1].offsetLeft - first.offsetLeft : first.offsetWidth;
        const current = this.track.scrollLeft;
        const left = direction > 0 && current >= max - 2 ? 0
          : direction < 0 && current <= 2 ? max
          : Math.min(max, Math.max(0, (Math.round(current / step) + direction) * step));
        this.track.scrollTo({ left, behavior: this.motion.matches ? 'auto' : 'smooth' });
      }
      update() {
        const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.controls.hidden = !overflow;
        const start = this.cards[0].offsetLeft;
        const left = this.track.scrollLeft;
        const right = left + this.track.clientWidth;
        const visible = this.cards.map((card, index) => ({ card, index }))
          .filter(({ card }) => card.offsetLeft - start + card.offsetWidth > left + 4 && card.offsetLeft - start < right - 4);
        if (visible.length) this.position.textContent = `${visible[0].index + 1}–${visible[visible.length - 1].index + 1} / ${this.cards.length}`;
        if (this.toggle) {
          this.toggle.disabled = this.motion.matches;
          this.toggle.setAttribute('aria-pressed', String(this.paused));
          const label = this.motion.matches ? 'Automatic rotation disabled for reduced motion' : this.paused ? 'Play feedback carousel' : 'Pause feedback carousel';
          this.toggle.setAttribute('aria-label', label);
          this.toggle.title = label;
          this.toggle.querySelector('[data-feedback-pause]').hidden = this.paused;
          this.toggle.querySelector('[data-feedback-play]').hidden = !this.paused;
        }
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || !this.visible || document.hidden || this.motion.matches || this.controls.hidden) return;
        this.timer = setTimeout(() => this.move(1), Math.max(5000, Number(this.dataset.interval) || 7000));
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.events?.abort();
        this.resize?.disconnect();
        this.intersection?.disconnect();
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
